export class TripReq{
    id:number;
    openingKms: number;
    closingKms: number;
    totalKms: number;
    extraHours: number;
    extraKms: number;
    bata: number;
    tollCharges: number;
    totalAmount: number;
    onDutyTime: string;
    offDutyTime: string;
    type: any;
    slabId: number;
    cost: number;
    isActive: boolean;
    createdUser: string | null;
    createdAt: Date;
    updatedUser: string | null;
    versionFlag: number;
    constructor(
        id: number,
        openingKms: number,
        closingKms: number,
        totalKms: number,
        extraHours: number,
        extraKms: number,
        bata: number,
        tollCharges: number,
        totalAmount: number,
        onDutyTime: string,
        offDutyTime: string,
        type: any,
        slabId: number,
        cost: number,
        isActive?: boolean,
        createdUser?: string | null,
        createdAt?: Date,
        updatedUser?: string | null,
        versionFlag?: number

    ){
        this.id=id
        this.openingKms=openingKms
        this.closingKms=closingKms
        this.totalKms=totalKms
        this.extraHours=extraHours
        this.extraKms=extraKms
        this.bata=bata
        this.slabId=slabId
        this.cost=cost
        this.tollCharges=tollCharges
        this.totalAmount=totalAmount
        this.onDutyTime=onDutyTime
        this.offDutyTime=offDutyTime
        this.type=type
        this.isActive=isActive
        this.createdUser=createdUser
        this.updatedUser=updatedUser
        this.createdAt=createdAt
        this.versionFlag=versionFlag
    }

}